import { schema } from "normalizr";

import { TranslatableMap } from "./localisation";
import { ApiModel } from "./model";

interface Image extends ApiModel {
    kind: "image";
    label: string;
    alt: string;
    format_ext: string;
    fullsize_file_id: number;
    thumb_medium_file_id: number;
    thumb_small_file_id: number;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    fullsize_file: number | File;
    thumb_medium_file: number | File;
    thumb_small_file: number | File;
}

interface File extends ApiModel {
    kind: "file";
    file: string;
    orig_filename: string;
    disk: string;
    url: string;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    format?: FileFormat;
}

interface FileFormat {
    ext: string;
    label: TranslatableMap;
    label_short: TranslatableMap;
    mime_type: string;
}

const NFileFormat = new schema.Entity("fileFormats", {}, {
    idAttribute: "ext",
});

const NFile = new schema.Entity("files", {
    format: NFileFormat,
});

interface FilesNormalisedEntities {
    files?: {
        [key: number]: File;
    };
    images?: {
        [key: number]: Image;
    };
    fileFormats?: {
        [key: string]: FileFormat;
    };
}

export {
    Image,
    File,
    FileFormat,
    NFile,
    NFileFormat,
    FilesNormalisedEntities,
};
